"use client";

import dynamic from "next/dynamic";

import type { AccordionCardsProps } from "./AccordionCards";

const AccordionCards = dynamic(() => import("./AccordionCards"));

export default function AccordionCardsWrapper(props: AccordionCardsProps) {
  return <AccordionCards {...props} />;
}
